import React, { useEffect } from 'react';
import { Typography, Tag } from 'antd';
import Logo from '../../assets/images/logo512.png';
import LogoText from '../../assets/images/logotextlight.png';
import MainLayout from '../../components/MainLayout';
import { ABOUT_DESCRIPTION, ABOUT_TAGS, AboutTag } from '../../config/constants';
import styles from './About.module.css';

export interface AboutProps {};

// shows information about website
const About = (props: AboutProps): JSX.Element | null => {
  // set document title
  useEffect(() => {
    document.title = 'About | Sigmoid Academy';
  }, []);

  return (
    <div>
      <MainLayout selectedKey='about'>
        <div className={styles.mainContainer}>
          <div className={styles.logoContainer}>
            <img alt="Sigmoid Academy" src={Logo} className={styles.logoImg}/>
            <img alt="Sigmoid Academy" src={LogoText} className={styles.logoText}/>
          </div>
          <div className={styles.textContainer}>
            <Typography.Title level={3} className={styles.title}>
              About
            </Typography.Title>
            {ABOUT_DESCRIPTION.map((paragraph: string, index: number) => (
              <Typography.Text key={index} className={styles.text}>
                {paragraph}
              </Typography.Text>
            ))}
            <div className={styles.socialsContainer}>
              {ABOUT_TAGS.map((tag: AboutTag, index: number) => (
                <a
                  key={index}
                  href={tag.url}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Tag icon={<tag.Icon />} color={tag.color}>
                    {tag.label}
                  </Tag>
                </a>
              ))}
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
};

export default About;
